import { axiosInstance } from '@/lib/utils';
import { endpoints } from '@/api';
import type {
  Notification,
  PaginatedNotifications,
  RequestResponse,
} from '@/types';

export const fetchNotifications = async (page?: number) => {
  const response = await axiosInstance.get<
    RequestResponse<PaginatedNotifications>
  >(endpoints.notifications, { params: page ? { page } : undefined });
  const data = response.data.data;
  return (
    data ?? {
      nextPage: 0,
      currentPage: 1,
      lastPage: 1,
      currentPagesize: 0,
      total: 0,
      data: [] as Notification[],
    }
  );
};

export const fetchUnreadNotificationCount = async () => {
  const response = await axiosInstance.get<RequestResponse<number>>(
    endpoints.notificationUnreadCount
  );
  return response.data.data ?? 0;
};
